<template>
  <div id="tagComments">
    <TagComments
      v-if="step == 1"
      @newTag="step = 2"
      @editTagComment="editTag($event)"
    ></TagComments>
    <NewTagComments
      v-else
      @tagComments="TagComments()"
      :itemEdit="dataEdit"
    ></NewTagComments>
  </div>
</template>
<script>
import TagComments from "@/components/tagConfigComments/tagConfigComments";
import NewTagComments from "@/components/tagConfigComments/newTagComments";
export default {
  components: {
    TagComments,
    NewTagComments,
  },
  data() {
    return {
      step: 1,
      dataEdit: "",
    };
  },
  methods: {
    editTag(item) {
      this.dataEdit = item;
      this.step = 2;
    },
    TagComments() {
      this.step = 1;
      this.dataEdit = "";
    },
  },
};
</script>
<style lang="scss">
#tagComments {
  padding: 2rem;
  margin: -12px;
  border-radius: 0.5rem 0.5rem 0rem 0rem !important;
  width: auto;
  height: calc(100vh - 64px);
  animation: fade 1s ease-in-out;
}
</style>
